// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"493b4c70","152":"9b022f43","326":"139bb408","330":"dd4ea790","339":"3c9311b1","657":"493b4c70","709":"d253cdbe","908":"ec9c40d4"}[chunkId] + ".chunk.css";
};